module.exports = __webpack_public_path__ + "static/media/Priest_Shadow.252dc361.png";